/** @format */
import { css } from 'styled-components';

import { LoginFormProps } from './index';

/**
 * Base styles for the login form component
 *
 * @param {LoginFormProps} props The login form properties object
 * */
const baseStyles = (props: LoginFormProps) => css`
    max-width: 36rem;
    width: 100%;
    margin: 0 auto var(--layout-spacing-24);
    text-align: left;

    .text-center {
        text-align: center;
    }

    .forgot-password {
        text-align: right;
        margin-bottom: 1.2rem;
    }

    .error-message {
        margin-bottom: 2.4rem;
    }

    .submit {
        text-align: center;
    }

    .modal & {
        margin-bottom: 0;
    }

    > p {
        margin-bottom: var(--layout-spacing-24);
    }
`;

/**
 * The login form component styles
 *
 * @param {LoginFormProps} props The login form properties object
 * */
export const styles = (props: LoginFormProps) => css`
    ${baseStyles(props)}
`;
